import { Download } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

import { useBusiness } from '@/contexts/BusinessContext'

export const TaxReports = () => {
  const { formatCurrency } = useBusiness()

  // Mock data
  const report = {
    period: 'Last 30 days',
    totalCollected: 45680.5,
    orderCount: 1245,
    breakdown: [
      {
        taxRateName: 'Standard Rate (NY)',
        rate: 8.875,
        taxableAmount: 350000.0,
        taxCollected: 31062.5,
        orderCount: 850,
      },
      {
        taxRateName: 'California State Tax',
        rate: 7.25,
        taxableAmount: 150000.0,
        taxCollected: 10875.0,
        orderCount: 320,
      },
      {
        taxRateName: 'VAT (UK)',
        rate: 20.0,
        taxableAmount: 18715.0,
        taxCollected: 3743.0,
        orderCount: 75,
      },
    ],
  }

  const taxableTotal = report.breakdown.reduce((acc, curr) => acc + curr.taxableAmount, 0)

  return (
    <div>
      <div className="flex flex-col gap-2 border-t border-border-subtle p-4 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="text-heading-md text-ink">Tax report: {report.period}</h3>
        <Button variant="secondary">
          <Download />
          Export
        </Button>
      </div>

      <dl className="grid grid-cols-1 border-t border-border-subtle sm:grid-cols-3 sm:divide-x sm:divide-border-subtle">
        <div className="space-y-1 p-4">
          <dt className="text-sm text-text-2">Total tax collected</dt>
          <dd className="text-heading-lg tabular-nums text-ink">{formatCurrency(report.totalCollected)}</dd>
        </div>
        <div className="space-y-1 border-t border-border-subtle p-4 sm:border-t-0">
          <dt className="text-sm text-text-2">Taxable amount</dt>
          <dd className="text-heading-lg tabular-nums text-ink">{formatCurrency(taxableTotal)}</dd>
        </div>
        <div className="space-y-1 border-t border-border-subtle p-4 sm:border-t-0">
          <dt className="text-sm text-text-2">Orders with tax</dt>
          <dd className="text-heading-lg tabular-nums text-ink">{report.orderCount.toLocaleString()}</dd>
        </div>
      </dl>

      <div className="border-t border-border-subtle">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tax</TableHead>
              <TableHead className="text-right">Rate</TableHead>
              <TableHead className="text-right">Taxable amount</TableHead>
              <TableHead className="text-right">Tax collected</TableHead>
              <TableHead className="text-right">Orders</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {report.breakdown.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium text-ink">{item.taxRateName}</TableCell>
                <TableCell className="text-right tabular-nums">{item.rate}%</TableCell>
                <TableCell className="text-right tabular-nums">{formatCurrency(item.taxableAmount)}</TableCell>
                <TableCell className="text-right tabular-nums">{formatCurrency(item.taxCollected)}</TableCell>
                <TableCell className="text-right tabular-nums">{item.orderCount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
